module.exports = __webpack_public_path__ + "static/item-5-0ffadd05ac923aa125866745c7913cd0.png";